// Curated screenshot presets for the demos index reel.

export interface ShotPresetMeta {
  readonly id: string;
  readonly order: number;
}

export const SHOT_PRESETS: readonly ShotPresetMeta[] = [
  { order: 1, id: 'family-zoo' },
  { order: 2, id: 'transformations' },
  { order: 3, id: 'composition' },
  { order: 4, id: 'inverses' },
  { order: 5, id: 'domain-range-lab' },
  { order: 6, id: 'behavior-and-features' },
  { order: 7, id: 'piecewise-builder' },
  { order: 8, id: 'representations' },
];
